module.exports = __webpack_public_path__ + "media/images/athletes/1405-964e19eea3013ac70fbf0f1b39405511.png";